var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"event-header-hero tw-px-6 lg:tw-px-[78px] tw-px-6"},[_c('h1',{staticClass:"event-header-hero__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"event-header-hero__slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }